module.exports = __webpack_public_path__ + "img/Companycultrue-culture.40941683.png";